module.exports = __webpack_public_path__ + "img/ins_step4_success.d2241821.svg";